import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import './index.css';

// Facebook SDK Loader Component
function FacebookSDKLoader() {
    useEffect(() => {
        if (document.getElementById('facebook-jssdk')) return; // prevent duplicate load

        // Load SDK script
        const script = document.createElement('script');
        script.id = 'facebook-jssdk';
        script.src = 'https://connect.facebook.net/en_US/sdk.js';
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);

        // Initialize SDK when loaded
        (window as any).fbAsyncInit = function () {
            (window as any).FB.init({
                appId: 'YOUR_FACEBOOK_APP_ID_HERE',
                cookie: true,
                xfbml: true,
                version: 'v21.0', // updated to latest Graph API version
            });
        };
    }, []);

    return null;
}

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <GoogleOAuthProvider clientId="YOUR_GOOGLE_CLIENT_ID_HERE">
                <QueryClientProvider client={queryClient}>
                    <FacebookSDKLoader />
                    <App />
                </QueryClientProvider>
            </GoogleOAuthProvider>
        </BrowserRouter>
    </React.StrictMode>
);

